<template>
  <v-tooltip top>
    <template #activator="{ on, attrs }">
      <v-icon v-bind="attrs" :color="color" style="cursor: pointer;" v-on="on"> mdi-{{ icon }} </v-icon>
    </template>
    <span>{{ hint }}</span>
  </v-tooltip>
</template>

<script>
export default {
  name: "CaActionIcon",
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: "card-outline"
    },
    color: {
      type: String,
      default: "default"
    },
    hint: {
      type: String,
      default: "Hint"
    }
  }
};
</script>
